import { fetchRequest } from "@providers/conect";

const getLogsApi = async (data) => {
  try {
    const { tipo, fecha_inicio, fecha_fin, limit } = data;
    const queryParams = new URLSearchParams();
    if (tipo) queryParams.append('tipo', tipo);
    if (fecha_inicio) queryParams.append('fecha_inicio', fecha_inicio);
    if (fecha_fin) queryParams.append('fecha_fin', fecha_fin);
    if (limit) queryParams.append('limit', limit);

    const url = `logs?${queryParams.toString()}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getLogsApi };
